"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebSocketConnection = exports.webSocketContext = void 0;
const react_1 = require("react");
exports.webSocketContext = react_1.createContext(undefined);
// Please note that you need to wait for the subscription confirmation of your channel
// before you can send messages to it.
// This isn't implemented anywhere at the moment, but might be necessary for future features.
const useWebSocketConnection = () => react_1.useContext(exports.webSocketContext);
exports.useWebSocketConnection = useWebSocketConnection;
